import { createFileRoute, notFound } from '@tanstack/react-router'

/**
 * Projects are brand-scoped. A legacy workspace-wide URL cannot identify which
 * brand's Projects tab should open, so it must not render a global list or
 * guess a destination. Use `/w/$workspaceId/brands/$brandId?tab=projects`.
 */

export const Route = createFileRoute('/_ws/w/$workspaceId/projects/')({
  beforeLoad: () => {
    throw notFound()
  },
})
